import { useState, useEffect } from "react";
import Chart from "chart.js/auto";
import { Pie } from "react-chartjs-2";
import { CategoryScale } from "chart.js";
import { TextInput, Slider } from "@mantine/core";
import { useForm } from "@mantine/form";
import { Table, Thead, Tbody, Tr, Td } from "react-super-responsive-table";
import { BrowserView, MobileView } from "react-device-detect";

Chart.register(CategoryScale);

const Shreyas = () => {

const [isVisible,setIsVisible]=useState(false)
const [metal,setMetal]=useState("gold")


const handleButtonClick=()=>setIsVisible(!isVisible)

const [rates,setRates]=useState({
gold:0,
silver:0
})

/* Redemption rate */

const [redeemRate,setRedeemRate]=useState<number>(0)

/* API */

useEffect(()=>{

fetch("https://apis.bhimagold.com/api_db.js/api/v1//todaysgoldrate")
.then(res=>res.json())
.then(data=>{

let gold = Number(data.gold22k.replace(/,/g,''))
let silver = Number(data.silver.replace(/,/g,''))

setRates({
gold:gold,
silver:silver
})



})

},[])


/* Form */

const form=useForm({

initialValues:{
installmentAmt:10000,
numInstallment:11,
va:18
}

})

/* Formatter */

const formatter=new Intl.NumberFormat('en-IN',{
style:'currency',
currency:'INR',
maximumFractionDigits:2
})

const formatter1=new Intl.NumberFormat('en-IN',{
style:'currency',
currency:'INR',
maximumFractionDigits:0
})

/* Rate state */

const [rateState,setRateState]=useState(
Array.from({length:11},(_,i)=>({
rate:0,
weight:0
}))
)

const [totalWt,setTotalWt]=useState(0)

/* Initialize monthly rates */

useEffect(()=>{

let base = metal==="gold" ? rates.gold : rates.silver

if(base===0) return

let arr:any[]=[]

let currentRate = base

for(let i=0;i<11;i++){

arr.push({
rate: currentRate,
weight: form.values.installmentAmt/currentRate
})

currentRate = Math.trunc(currentRate + (currentRate*0.005))

}

setRedeemRate(currentRate)

setRateState(arr)

},[rates,metal,form.values.installmentAmt])
/* Recalculate total weight */

useEffect(()=>{

let total = rateState.reduce((sum:any,r:any)=>{

return sum + r.weight

},0)

setTotalWt(total)

},[rateState])

useEffect(()=>{

let updatedRates = rateState.map((r:any)=>{

if(r.rate > 0){

return {
rate: r.rate,
weight: form.values.installmentAmt / r.rate
}

}

return r

})

setRateState(updatedRates)

},[form.values.installmentAmt])
/* Benefit logic */

const benefitPercent=()=>{

if(form.values.va<=18)
return form.values.va

return 18

}

/* Benefit ₹ */

const benefitInRs = totalWt * (benefitPercent()/100) * redeemRate
const diamondBenefit = form.values.installmentAmt * 2
/* Chart */

const getChartData = () => {

let benefit = metal === "diamond"
? form.values.installmentAmt * 2
: totalWt * benefitPercent() / 100

let accumulated = metal === "diamond"
? form.values.installmentAmt * form.values.numInstallment
: totalWt

return {

labels: metal === "diamond"
? [
`Benefit Offered (₹${benefit.toLocaleString()})`,
`Total Amount Paid (₹${accumulated.toLocaleString()})`
]
: [
`Benefit Offered (${benefit.toFixed(3)}g)`,
`Accumulated Weight (${totalWt.toFixed(3)}g)`
],

datasets:[{

data:[benefit, accumulated],

backgroundColor:["#f6b800","#c7931d"],

borderColor:"#555",

borderWidth:2

}]

}

}

const chartData=getChartData()

/* Change monthly rate */
const rateFormatter = new Intl.NumberFormat("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
const changeRate = (index: number, value: string) => {

let cleanValue = value.replace(/,/g, "")

let num = Number(cleanValue)

let newRates = [...rateState]

if(!isNaN(num) && num > 0){

newRates[index].rate = num
newRates[index].weight = form.values.installmentAmt / num

}else{

newRates[index].rate = 0
newRates[index].weight = 0

}

setRateState(newRates)

}
useEffect(()=>{

let updatedRates = rateState.map((r:any)=>{

if(r.rate > 0){

return {
rate: r.rate,
weight: form.values.installmentAmt / r.rate
}

}

return r

})

setRateState(updatedRates)

},[form.values.installmentAmt])
/* UI */
const benefitWeight = () => {

if(metal === "diamond"){
return 0
}

return totalWt * (benefitPercent() / 100)

}

const redemptionWeight = () => {
return totalWt + benefitWeight()
}
const totalAmountPayable = form.values.installmentAmt * form.values.numInstallment

return(

<div className="page-content">

<div className="container-fluid">

<div className="row">

{/* LEFT PANEL */}

<div className="col-md-4">

<label>
<input type="radio" checked={metal==="gold"} onChange={()=>setMetal("gold")} style={{marginRight:2}} />
Gold
</label>

<label style={{marginLeft:20}}>
<input type="radio" checked={metal==="silver"} onChange={()=>setMetal("silver")} style={{marginRight:2}} />
Silver
</label>

<label style={{marginLeft:20}}>
<input type="radio" checked={metal==="diamond"} onChange={()=>setMetal("diamond")} style={{marginRight:2}} />
Diamond & Platinum
</label>

<br/><br/>

{/* Installment Slider */}

<div style={{display:"flex",flexDirection:"column",gap:"3px"}}>

<div style={{display:"flex",justifyContent:"space-between"}}>
<label>Installment Amount</label>
<div>{formatter1.format(form.values.installmentAmt)}</div>
</div>

<Slider
{...form.getInputProps("installmentAmt")}
min={1000}
max={100000}
step={1000}
styles={{
track:{backgroundColor:'#f6b800'},
thumb:{backgroundColor:'#ffffff',border:'4px solid #c7931d'},
bar:{backgroundColor:'#f6b800'}
}}
/>

</div>

<br/>
<div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>

<div style={{ display: "flex", justifyContent: "space-between" }}>
<label>No. of Installments :</label>
<div>{form.values.numInstallment}</div>
</div>

<div style={{ position: "relative", width: "100%" }}>

<div
style={{
position: "absolute",
width: "100%",
height: "8px",
background: "#f6b800",
borderRadius: "5px",
zIndex: 0
}}
/>

<div
style={{
position: "absolute",
width: "100%",
height: "8px",
background: "#f6b800",
borderRadius: "5px",
zIndex: 1
}}
/>

<input
type="range"
min={1}
max={11}
step={1}
value={form.values.numInstallment}
disabled
style={{
width: "100%",
height: "8px",
cursor: "default",
opacity: 0,
zIndex: 2
}}
/>

</div>

</div>
<br></br>
{/* VA Slider */}

{metal!=="diamond" && (

<div>

<div style={{display:"flex",justifyContent:"space-between"}}>
<label>Net Making Charges:</label>
<div>{form.values.va}%</div>
</div>

<Slider
{...form.getInputProps("va")}
min={1}
max={40}
styles={{
track:{background:"#f6b800"},
thumb:{background:"#fff",border:"4px solid #c7931d"},
bar:{background:"#f6b800"}
}}
/>

</div>

)}

</div>

{/* CENTER PANEL */}

<div className="col-md-5">

<table className="table table-striped">

<thead>

<tr>
<td>{metal==="diamond" ? "Total Amount Paid:" : "Total Accumulated Weight:"}</td>

<td style={{textAlign:"right"}}>
<strong>
{metal==="diamond"
? formatter.format(totalAmountPayable)
: `${totalWt.toFixed(3)}g`}
</strong>
</td>
</tr>

</thead>

<tbody>

<tr>
<td>Benefit Offered:</td>
<td style={{textAlign:"right"}}>
<strong>
{metal==="diamond"
? formatter.format(diamondBenefit)
: `${benefitWeight().toFixed(3)}g`}
</strong>
</td>

</tr>

<tr>
<td>{metal==="diamond" ? "Redemption Value:" : "Redemption Weight:"}</td>

<td style={{textAlign:"right"}}>
<strong>
{metal==="diamond"
? formatter.format(totalAmountPayable + diamondBenefit)
: `${redemptionWeight().toFixed(3)}g`}
</strong>
</td>
</tr>

</tbody>

</table>

<div className="card">

<div className="card-body">

<b>Benefit:</b>
<br/>

{metal==="diamond" ? (

<>
You get benefit worth <b>{formatter.format(diamondBenefit)} </b>
(Equivalent to <b>2 Installments</b> in this example)
</>

) : (

<>
No need to pay Making charges up to <b>{benefitPercent()}% </b>on Product (s) weighing <b>{totalWt.toFixed(3)}g </b>
(Effectively you get benefit worth <b>{benefitWeight().toFixed(3)}g of {metal==="silver"?"Silver":"22Kt Gold"}</b> in this example)
</>

)}
</div>

</div>

</div>

{/* PIE CHART */}

<div className="col-md-3">


<Pie
 data={chartData}
 height={128}
 width={128}
 options={{
   plugins: {
     legend: {
       position: "top",
       labels: {
         boxWidth: 12,
         padding: 10,
         font: {
           size: 10
         }
       }
     }
   }
 }}
/>
</div>

</div>
<BrowserView>
<div className="row indicator">
    <div className="col-md-3"></div>

    <div className="col-md-6">
        <p className="calculatorFor">

            <a
            href="/?scheme_name=kubera&show_menu=0&show_title=0"
            className="previous round"
            style={{color:"white", marginRight:5}}
            >
            &#8592;
            </a>

            Sample Calculator For <b className="jppName">Shreyas</b>

            <a
            href="/?scheme_name=samruddhi&show_menu=0&show_title=0"
            className="next round"
            style={{color:"white",marginLeft:5}}
            >
            &#8594;
            </a>

        </p>
    </div>

    <div className="col-md-3">
    <div className="card-body" style={{textAlign:"center"}}>
        <br/>

        <p style={{fontSize:"13px"}}>
            The benefits and other details shown above are only indicative.
        </p>

        For more details contact Bhima Helpline
        <a href="tel:1800-121-9076">1800-121-9076</a>
    </div>
</div>

</div>
</BrowserView>
<MobileView>

<div className="row indicator">

    <div className="col-md-3"></div>

    <div className="col-md-6">
    <p style={{fontSize:"12px", color:"#777", textAlign:"center"}}>
        The benefits and other details shown above are only indicative.
    </p>

    <p className="calculatorFor">
        Sample Calculator For <b className="jppName">Shreyas</b>
    </p>
</div>

    <div className="col-md-3"></div>

</div>


<div className="row indicator">

    <div className="col-md-5"></div>

    <div className="col-md-2" style={{textAlign:"center"}}>

        <a
        href="/?scheme_name=kubera&show_menu=0&show_title=0"
        className="previous round"
        style={{color:"white"}}
        >
        &#8592;
        </a>

        &nbsp;&nbsp;&nbsp;

        <a
        href="/?scheme_name=samruddhi&show_menu=0&show_title=0"
        className="next round"
        style={{color:"white"}}
        >
        &#8594;
        </a>

    </div>

    <div className="col-md-5">
        <div className="card-body" style={{textAlign:"center"}}>
            <br/>
            For more details contact Bhima Helpline
            <a href="tel:1800-121-9076">1800-121-9076</a>
        </div>
    </div>

</div>

</MobileView>
{/* HELPLINE */}

<div className="row indicator">

<div className="col-md-3"></div>

<div className="col-md-6">



</div>

<div className="col-md-3">



</div>

</div>

{/* VIEW MORE */}

{metal!=="diamond" && (
<button onClick={handleButtonClick}  className="btn btn-warning text-white" >
{isVisible ? "View Less.." : "View More.."}
</button>
)}

{metal!=="diamond" && isVisible && (

<div>

<br/>

<Table className="table table-bordered table-striped">

<Thead>

<Tr>
<Td><b>No. of Inst.</b></Td>
<Td><b>Inst. Amount</b></Td>
<Td><b>Metal Rate*</b></Td>
<Td><b>Wt. Credit</b></Td>
</Tr>

</Thead>

<Tbody>

{rateState.map((r,i)=>(

<Tr key={i}>

<Td>{i+1}</Td>

<Td>{formatter.format(form.values.installmentAmt)}</Td>

<Td>

<TextInput
value={rateFormatter.format(r.rate)}
onChange={(e)=>changeRate(i,e.target.value)}
size="xs"
/>

</Td>

<Td>{r.weight.toFixed(3)} g</Td>

</Tr>

))}

<Tr>

<Td><b>Total</b></Td>

<Td><b>{formatter.format(form.values.installmentAmt*11)}</b></Td>

<Td></Td>

<Td><b>{totalWt.toFixed(3)} g</b></Td>

</Tr>

</Tbody>

</Table>

{/* Redemption */}

<div className="card">

<div className="card-body">

<div className="row">

<div className="col-md-3">
Assumed {metal === "silver" ? "silver" : "gold"} rate on the day of Redemption
</div>

<div className="col-md-4">
<TextInput
value={redeemRate ? rateFormatter.format(redeemRate) : ""}
onChange={(e)=>{
  let cleanValue = e.target.value.replace(/,/g,"")
  let num = Number(cleanValue)

  if(!isNaN(num)){
    setRedeemRate(num)
  }
}}
/>
</div>

<div className="col-md-2"></div>

<div className="col-md-3">
<b>
You get benefit worth: {formatter.format(benefitInRs)}


</b>
</div>

</div>

</div>

</div>

<br/>

Metal Rate* : Metal Rate on the day of payment,

Inst. : Installment ,

Wt. : Weight

</div>

)}

</div>

</div>

)

}

export default Shreyas